wbApp.factory('onlinePaymentConfigurationSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var OnlinePaymentConfiguration = $resource('/restapi/online-payment-configurations/:id', {}, {
            'get': { method: 'GET', url: '/restapi/online-payment-configurations/:id' },
            'getAll': { method: 'GET', isArray: true, url: '/restapi/online-payment-configurations' },
            'update': { method: 'PUT', url: '/restapi/online-payment-configurations/:id' },
            'insert': { method: 'POST', url: '/restapi/online-payment-configurations' },
            'delete': { method: 'DELETE', url: '/restapi/online-payment-configurations/:id' }
        });

        var onlinePaymentConfigurations;


        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                OnlinePaymentConfiguration,
                model);
        }

        function remove(id) {
            onlinePaymentConfigurations = null;
            return repositorySvc.customDelete(
                'delete',
                OnlinePaymentConfiguration,
                { id: id });
        }

        function update(model) {
            onlinePaymentConfigurations = null;
            return repositorySvc.customPutWithParams(
                'update',
                OnlinePaymentConfiguration,
                { id: model.id },
                model);
        }

        function getById(id) {
            return repositorySvc.customGet('get', OnlinePaymentConfiguration, { id: id });
        }

        function getAll(refresh) {
            if (!onlinePaymentConfigurations || refresh) {
                onlinePaymentConfigurations = repositorySvc.customGet('getAll', OnlinePaymentConfiguration, {});
            }
            return onlinePaymentConfigurations;
        }


        function createNew() {
            return {
                id: null,
                providerType: 0,
                isTestConfig: true,
                country: 'CZ',
                secret: {
                    clientCertificateBase64: null,
                    merchantID: null,
                    merchantPassword: null
                }
            };
        }

        return {
            getAllAsync: getAll,
            getAsync: getById,
            insert: insert,
            update: update,
            remove: remove,
            createNew: createNew
        }

    }]);